/* global $ */

import dataLayerHelper from '../helpers/dataLayer';

const $bar = $('.js-cookie-bar');

const SAVE_FOR_DAYS = 365;

const cookieBar = {
  initialize() {
    if ($bar.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $bar.on('click', '.js-cookie-bar-btn', () => {
      this.acceptedCookies();
    });
  },

  /**
   * Saves a cookie with the given data
   * @param {String} name
   * @param {String} value
   * @param {Number} days
   * @return {void}
   */
  setCookie(name: string, value: string, days: number) {
    let expires = '';

    const HOURS_DAY = 24;
    const MINUTES_HOUR = 60;
    const SECONDS_MINUTE = 60;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * HOURS_DAY * MINUTES_HOUR * SECONDS_MINUTE * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${(value || '')}${expires}; path=/`;
  },

  /**
   * The user accepted cookies, Yay!
   * @return {void}
   */
  acceptedCookies() {
    $bar.css({
      opacity: 0,
      transform: 'translateY(30px)',
    });

    this.setCookie('cookies_accepted', 1, SAVE_FOR_DAYS);

    dataLayerHelper.event('Cookie bar', 'closed');
  },
};

export default cookieBar;
